import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import logo from "images/lra_pink.svg";
import {
  Container, Content, MainContainer, LogoLink, LogoImage, MainContent,
  Heading, FormContainer, Form
} from "./AuthStyles";

const DividerTextContainer = tw.div`my-12 border-b text-center relative`;
const DividerText = tw.div`leading-none px-2 inline-block text-sm text-gray-600 tracking-wide font-medium bg-white transform -translate-y-1/2 absolute inset-x-0 top-1/2 bg-transparent`;
const InfoText = tw.p`text-center text-gray-700 leading-relaxed`;

export default ({
  logoLinkUrl = "#",
  headingText = "Verify Email Address",
}) => (
  <AnimationRevealPage>
    <Container>
      <Content>
        <MainContainer>
          <LogoLink href={logoLinkUrl}>
            <LogoImage src={logo} />
          </LogoLink>
          <MainContent>
            <Heading>{headingText}</Heading>
            <FormContainer>
              <DividerTextContainer>
                <DividerText>Thank you for signing up!</DividerText>
              </DividerTextContainer>
              <Form>
                <InfoText>To complete your registration, please verify your email address.</InfoText>
                <InfoText tw="mt-4">Go to the email used to register, and click on the verification link sent.</InfoText>
              </Form>
            </FormContainer>
          </MainContent>
        </MainContainer>
      </Content>
    </Container>
  </AnimationRevealPage>
);
